export default "__VITE_ASSET__BzhRu4qm__"